import axios from "src/utils/axios";
import { createSlice } from "@reduxjs/toolkit";

// ----------------------------------------------------------------------

const initialState = {
  paymentMethods: [],
  paymentMethod: null,
  error: false,
};

const slice = createSlice({
  name: "paymentMethods",
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    createPaymentSuccess(state, action) {
      state.paymentMethods = [...state.paymentMethods, action.payload];
    },
    getPaymentsSuccess(state, action) {
      state.paymentMethods = action.payload;
    },
    getPaymentByIdSuccess(state, action) {
      state.paymentMethod = state.paymentMethods.find(
        (payment) => payment.id === action.payload
      );
    },
    updateSuccess(state, action) {
      const update = action.payload;

      state.paymentMethods = state.paymentMethods.map((payment) =>
        payment.id === update.id ? { ...payment, ...update } : payment
      );

      if (state.paymentMethod && state.paymentMethod.id === update.id) {
        state.paymentMethod = {
          ...state.paymentMethod,
          ...update,
        };
      }
    },
    deleteByIdSuccess(state, action) {
      state.paymentMethods = state.paymentMethods.map((payment) => {
        if (payment.id === action.payload) {
          return {
            ...payment,
            isActive: false,
          };
        }
        return payment;
      });

      if (state.paymentMethod && state.paymentMethod.id === action.payload) {
        state.paymentMethod = null;
      }
    },

    resetPaymentMethod(state) {
      state.paymentMethod = null;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  createPaymentSuccess,
  getPaymentsSuccess,
  getPaymentByIdSuccess,
  updateSuccess,
  deleteByIdSuccess,
  resetPaymentMethod,
} = slice.actions;

export function getPayments() {
  return async (dispatch) => {
    try {
      const response = await axios.get("alternativePayments/read");
      dispatch(slice.actions.getPaymentsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createPaymentMethod(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post("alternativePayments/create", data);
      dispatch(slice.actions.createPaymentSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updatePaymentMethod(data) {
  return async (dispatch) => {
    try {
      await axios.put(`alternativePayments/update`, data);
      dispatch(slice.actions.updateSuccess(data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deletePaymentMethod(id) {
  return async (dispatch) => {
    try {
      await axios.delete(`alternativePayments/delete/${id}`);
      dispatch(slice.actions.deleteByIdSuccess(id));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
